import WebsiteMenuMobile from 'pages/App/Header/Menu/WebsiteMenu/MobileView';
import styled from 'styled-components';

export default styled(WebsiteMenuMobile)`
  margin-left: 24px;
  ${(props) => props.theme.media.xs`
    margin-left: 0;
  `}
`;
